import { Divider } from "@mui/material";
import { Subtitulo } from "../..";
import CardCustom from "../../Card";
import { Fragment, useEffect, useState } from "react";
import { GetDadosCartaoPagamentoByID } from "../../../api/FormaPagamento";

const CartaoCredito = ({ pedido, isDetalhes = false, onError }) => {
  const [dadosCartao, setDadosCartao] = useState(null);
  const [errorMessage, setErrorMessage] = useState(null);
  const [loading, setLoading] = useState(false);

  // Busca simples com useEffect
  useEffect(() => {
    const fetchDadosCartao = async () => {
      const idCartaoPagamento = pedido?.dadosCartaoPagamento?.idCartaoPagamento;

      if (!idCartaoPagamento) {
        return;
      }

      setLoading(true);
      setErrorMessage(null);

      try {
        const response = await GetDadosCartaoPagamentoByID(idCartaoPagamento);

        if (!response || response.errorMessage) {
          throw new Error(
            response?.errorMessage || "Dados do cartão não encontrados"
          );
        }
        setDadosCartao(response.data);
      } catch (error) {
        const errorMsg = `Ops, algo deu errado, por favor informe o suporte o seguinte erro: ${error.message} - R34C8`;
        setErrorMessage(errorMsg);
        onError?.(errorMsg);
      } finally {
        setLoading(false);
      }
    };

    fetchDadosCartao();
  }, [pedido?.dadosCartaoPagamento?.idCartaoPagamento, onError]);

  if (!pedido?.dadosCartaoPagamento?.idCartaoPagamento) {
    return null;
  }

  if (loading) {
    return <div>Carregando dados do cartão...</div>;
  }

  if (errorMessage) {
    return <div style={{ color: "red" }}>{errorMessage}</div>;
  }

  return (
    <CardCustom isDetalhes={isDetalhes}>
      <Subtitulo sx={{ color: "#000", fontWeight: "BOLD", mb: 1 }}>
        💳 Pagamento via cartão de crédito
      </Subtitulo>
      
      <Divider sx={{ my: 1, borderColor: "#ccc" }} />

      {dadosCartao ? (
        <div>
          <Subtitulo sx={{ fontWeight: "bold", mb: 1, color: "#000" }}>
            Titular: {dadosCartao.nomeTitular}
          </Subtitulo>
          
          <Subtitulo sx={{ fontWeight: "bold", mb: 1, color: "#000" }}>
            Número: **** **** **** {dadosCartao.numero?.slice(-4)}
          </Subtitulo>
          
          <Subtitulo sx={{ fontWeight: "bold", mb: 1, color: "#000" }}>
            Parcelas: {pedido?.dadosCartaoPagamento?.quantidadeParcela || 1}x
          </Subtitulo>
          
          <Subtitulo sx={{ fontWeight: "bold", mb: 1, color: "#000" }}>
            Bandeira: {dadosCartao.bandeira}
          </Subtitulo>

          {/* Adicionando informações adicionais se disponíveis */}
          {dadosCartao.valorParcela && (
            <Subtitulo sx={{ fontWeight: "bold", mb: 1, color: "#000" }}>
              Valor por parcela: R$ {dadosCartao.valorParcela.toFixed(2)}
            </Subtitulo>
          )}
        </div>
      ) : (
        <Subtitulo sx={{ color: "#000" }}>
          Nenhum dado do cartão encontrado
        </Subtitulo>
      )}
    </CardCustom>
  );
};

export default CartaoCredito;